// features/sale/payment/salePaymentColumns.ts
import { CustomColumn } from '../../../types/customColumn';
import { MultipleSalePayment } from '../../../types/sale/payment/MultiplePaymentTypes';

export const salePaymentColumns: CustomColumn<MultipleSalePayment>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },
  {
    Header: 'Forma de Pago',
    accessor: 'paymentMethodName',
    customCell: ({ row }) => {
      const { paymentMethodName, reference } = row.original;
      const hasReference = reference && reference !== '-';

      return (
        <div className="flex flex-col text-sm leading-6 text-black dark:text-white">
          <span className="font-semibold uppercase">
            FORMA DE PAGO:{' '}
            <span className="font-normal normal-case">{paymentMethodName}</span>
          </span>
          {hasReference && (
            <span className="text-xs font-semibold text-black dark:text-white mt-1">
              NÚM. DE COMPROBANTE:{' '}
              <span className="font-normal">{reference}</span>
            </span>
          )}
        </div>
      );
    },
  },
  {
    Header: 'Monto',
    accessor: 'amount',
    customCell: ({ value }) => (
      <div className="text-sm font-semibold leading-6 text-green-600 dark:text-green-400">
        ${Number(value).toFixed(2)}
      </div>
    ),
  },
];
